import { GET_WHATSAPP_TEMPLATE, GET_WHATSAPP_TEMPLATE_SUCCESS, GET_WHATSAPP_TEMPLATE_ERROR, GET_WHATSAPP_TEMPLATE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetWhatsAppTemplate = (state = initialState, action) => {
  switch (action.type) {
    case GET_WHATSAPP_TEMPLATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_WHATSAPP_TEMPLATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_WHATSAPP_TEMPLATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_WHATSAPP_TEMPLATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetWhatsAppTemplate;
